/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as InstallAuthorizeRouteImport } from './routes/install/authorize'
import { Route as CliAuthorizeRouteImport } from './routes/cli/authorize'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedReposRouteImport } from './routes/_authed/repos'
import { Route as AuthedGettingStartedRouteImport } from './routes/_authed/getting-started'
import { Route as AuthedAgentViewRouteImport } from './routes/_authed/agent-view'
import { Route as AuthedRepoIdIndexRouteImport } from './routes/_authed/$repoId/index'
import { Route as AuthedRepoIdSetupRouteImport } from './routes/_authed/$repoId/setup'
import { Route as AuthedRepoIdSettingsRouteImport } from './routes/_authed/$repoId/settings'
import { Route as AuthedRepoIdDeployRouteImport } from './routes/_authed/$repoId/deploy'
import { Route as AuthedRepoIdSessionIdRouteImport } from './routes/_authed/$repoId/$sessionId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
  id: '/invite/$invitationId',
  path: '/invite/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const InstallAuthorizeRoute = InstallAuthorizeRouteImport.update({
  id: '/install/authorize',
  path: '/install/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const CliAuthorizeRoute = CliAuthorizeRouteImport.update({
  id: '/cli/authorize',
  path: '/cli/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReposRoute = AuthedReposRouteImport.update({
  id: '/repos',
  path: '/repos',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGettingStartedRoute = AuthedGettingStartedRouteImport.update({
  id: '/getting-started',
  path: '/getting-started',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAgentViewRoute = AuthedAgentViewRouteImport.update({
  id: '/agent-view',
  path: '/agent-view',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRepoIdIndexRoute = AuthedRepoIdIndexRouteImport.update({
  id: '/$repoId/',
  path: '/$repoId/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRepoIdSetupRoute = AuthedRepoIdSetupRouteImport.update({
  id: '/$repoId/setup',
  path: '/$repoId/setup',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRepoIdSettingsRoute = AuthedRepoIdSettingsRouteImport.update({
  id: '/$repoId/settings',
  path: '/$repoId/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRepoIdDeployRoute = AuthedRepoIdDeployRouteImport.update({
  id: '/$repoId/deploy',
  path: '/$repoId/deploy',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRepoIdSessionIdRoute = AuthedRepoIdSessionIdRouteImport.update({
  id: '/$repoId/$sessionId',
  path: '/$repoId/$sessionId',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/agent-view': typeof AuthedAgentViewRoute
  '/getting-started': typeof AuthedGettingStartedRoute
  '/repos': typeof AuthedReposRoute
  '/settings': typeof AuthedSettingsRoute
  '/cli/authorize': typeof CliAuthorizeRoute
  '/install/authorize': typeof InstallAuthorizeRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/$repoId/$sessionId': typeof AuthedRepoIdSessionIdRoute
  '/$repoId/deploy': typeof AuthedRepoIdDeployRoute
  '/$repoId/settings': typeof AuthedRepoIdSettingsRoute
  '/$repoId/setup': typeof AuthedRepoIdSetupRoute
  '/$repoId/': typeof AuthedRepoIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/agent-view': typeof AuthedAgentViewRoute
  '/getting-started': typeof AuthedGettingStartedRoute
  '/repos': typeof AuthedReposRoute
  '/settings': typeof AuthedSettingsRoute
  '/cli/authorize': typeof CliAuthorizeRoute
  '/install/authorize': typeof InstallAuthorizeRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/': typeof AuthedIndexRoute
  '/$repoId/$sessionId': typeof AuthedRepoIdSessionIdRoute
  '/$repoId/deploy': typeof AuthedRepoIdDeployRoute
  '/$repoId/settings': typeof AuthedRepoIdSettingsRoute
  '/$repoId/setup': typeof AuthedRepoIdSetupRoute
  '/$repoId': typeof AuthedRepoIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authed/agent-view': typeof AuthedAgentViewRoute
  '/_authed/getting-started': typeof AuthedGettingStartedRoute
  '/_authed/repos': typeof AuthedReposRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/cli/authorize': typeof CliAuthorizeRoute
  '/install/authorize': typeof InstallAuthorizeRoute
  '/invite/$invitationId': typeof InviteInvitationIdRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/$repoId/$sessionId': typeof AuthedRepoIdSessionIdRoute
  '/_authed/$repoId/deploy': typeof AuthedRepoIdDeployRoute
  '/_authed/$repoId/settings': typeof AuthedRepoIdSettingsRoute
  '/_authed/$repoId/setup': typeof AuthedRepoIdSetupRoute
  '/_authed/$repoId/': typeof AuthedRepoIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/agent-view'
    | '/getting-started'
    | '/repos'
    | '/settings'
    | '/cli/authorize'
    | '/install/authorize'
    | '/invite/$invitationId'
    | '/$repoId/$sessionId'
    | '/$repoId/deploy'
    | '/$repoId/settings'
    | '/$repoId/setup'
    | '/$repoId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/reset-password'
    | '/agent-view'
    | '/getting-started'
    | '/repos'
    | '/settings'
    | '/cli/authorize'
    | '/install/authorize'
    | '/invite/$invitationId'
    | '/'
    | '/$repoId/$sessionId'
    | '/$repoId/deploy'
    | '/$repoId/settings'
    | '/$repoId/setup'
    | '/$repoId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/reset-password'
    | '/_authed/agent-view'
    | '/_authed/getting-started'
    | '/_authed/repos'
    | '/_authed/settings'
    | '/cli/authorize'
    | '/install/authorize'
    | '/invite/$invitationId'
    | '/_authed/'
    | '/_authed/$repoId/$sessionId'
    | '/_authed/$repoId/deploy'
    | '/_authed/$repoId/settings'
    | '/_authed/$repoId/setup'
    | '/_authed/$repoId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  CliAuthorizeRoute: typeof CliAuthorizeRoute
  InstallAuthorizeRoute: typeof InstallAuthorizeRoute
  InviteInvitationIdRoute: typeof InviteInvitationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/invite/$invitationId': {
      id: '/invite/$invitationId'
      path: '/invite/$invitationId'
      fullPath: '/invite/$invitationId'
      preLoaderRoute: typeof InviteInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/install/authorize': {
      id: '/install/authorize'
      path: '/install/authorize'
      fullPath: '/install/authorize'
      preLoaderRoute: typeof InstallAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cli/authorize': {
      id: '/cli/authorize'
      path: '/cli/authorize'
      fullPath: '/cli/authorize'
      preLoaderRoute: typeof CliAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/repos': {
      id: '/_authed/repos'
      path: '/repos'
      fullPath: '/repos'
      preLoaderRoute: typeof AuthedReposRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/getting-started': {
      id: '/_authed/getting-started'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof AuthedGettingStartedRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/agent-view': {
      id: '/_authed/agent-view'
      path: '/agent-view'
      fullPath: '/agent-view'
      preLoaderRoute: typeof AuthedAgentViewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$repoId/': {
      id: '/_authed/$repoId/'
      path: '/$repoId'
      fullPath: '/$repoId/'
      preLoaderRoute: typeof AuthedRepoIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$repoId/setup': {
      id: '/_authed/$repoId/setup'
      path: '/$repoId/setup'
      fullPath: '/$repoId/setup'
      preLoaderRoute: typeof AuthedRepoIdSetupRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$repoId/settings': {
      id: '/_authed/$repoId/settings'
      path: '/$repoId/settings'
      fullPath: '/$repoId/settings'
      preLoaderRoute: typeof AuthedRepoIdSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$repoId/deploy': {
      id: '/_authed/$repoId/deploy'
      path: '/$repoId/deploy'
      fullPath: '/$repoId/deploy'
      preLoaderRoute: typeof AuthedRepoIdDeployRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$repoId/$sessionId': {
      id: '/_authed/$repoId/$sessionId'
      path: '/$repoId/$sessionId'
      fullPath: '/$repoId/$sessionId'
      preLoaderRoute: typeof AuthedRepoIdSessionIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAgentViewRoute: typeof AuthedAgentViewRoute
  AuthedGettingStartedRoute: typeof AuthedGettingStartedRoute
  AuthedReposRoute: typeof AuthedReposRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedRepoIdSessionIdRoute: typeof AuthedRepoIdSessionIdRoute
  AuthedRepoIdDeployRoute: typeof AuthedRepoIdDeployRoute
  AuthedRepoIdSettingsRoute: typeof AuthedRepoIdSettingsRoute
  AuthedRepoIdSetupRoute: typeof AuthedRepoIdSetupRoute
  AuthedRepoIdIndexRoute: typeof AuthedRepoIdIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAgentViewRoute: AuthedAgentViewRoute,
  AuthedGettingStartedRoute: AuthedGettingStartedRoute,
  AuthedReposRoute: AuthedReposRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedRepoIdSessionIdRoute: AuthedRepoIdSessionIdRoute,
  AuthedRepoIdDeployRoute: AuthedRepoIdDeployRoute,
  AuthedRepoIdSettingsRoute: AuthedRepoIdSettingsRoute,
  AuthedRepoIdSetupRoute: AuthedRepoIdSetupRoute,
  AuthedRepoIdIndexRoute: AuthedRepoIdIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  CliAuthorizeRoute: CliAuthorizeRoute,
  InstallAuthorizeRoute: InstallAuthorizeRoute,
  InviteInvitationIdRoute: InviteInvitationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
